import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import CompanyProfile from './Components/CompanyProfile';
import Auction from './Components/Auction';
import Login from './Components/Login';
import Register from './Components/Register';
import AdminPanel from "./Components/AdminPanel";
import AddVehicle from "./Components/AddVehicle";
import Vehicles from "./Components/Vehicles";
import ViewUser from "./Components/ViewUser";
import CreateAccount from "./Components/CreateAccount";
import ViewSales from "./Components/ViewSales";
import AddSale from "./Components/AddSale";
import DocsShip from "./Components/DocsShip";
import ViewVolet from "./Components/ViewVolet";
import CreateVolet from "./Components/CreateVolet";
import AllocatedPayments from "./Components/AllocatedPayments";
import CreateAllocate from "./Components/CreateAllocate";
import Accounts from "./Components/Accounts";
import Portfolio from "./Components/Portfolio";
import EditVehicles from "./Components/EditVehicles";
import VehicleDetails from "./Components/VehicleDetails";
import SearchIndividual from "./Components/SearchIndividual";
import MiddleBanner from "./Components/MiddleBanner";
import TestMiddleBanner from "./Components/TestMiddleBanner";
import Footer from "./Components/Footer";
import SearchVehicle from "./Components/SearchVehicle";
import SearchResult from "./Components/SearchResult";
import Inventory from "./Components/Inventory";


function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us/company-profile" element={<CompanyProfile />} />
        <Route path="/services/auction" element={<Auction />} />
        <Route path="/sign-in" element={<Login />} />
        <Route path="/sign-up" element={<Register />} />
        <Route path="/admin-panel" element={<AdminPanel />} />
        <Route path="/add-vehicle" element={<AddVehicle />} />
        <Route path="/Vehicles" element={<Vehicles />} />
        <Route path="/view-user" element={<ViewUser />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/view-sales" element={<ViewSales />} />
        <Route path="/add-new-sale" element={<AddSale />} />
        <Route path="/documents-shipping" element={<DocsShip />} />
        <Route path="/volet" element={<ViewVolet />} />
        <Route path="/create-volet" element={<CreateVolet />} />
        <Route path="/view-payments" element={<AllocatedPayments />} />
        <Route path="/create-allocate" element={<CreateAllocate />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/edit-vehicle/:id" element={<EditVehicles />} />
        <Route path="/vehicle-details/:carId" element={<VehicleDetails />} />
        <Route path="/search-individual" element={<SearchIndividual />} />
        <Route path="/middle-banner" element={<MiddleBanner />} />
        <Route path="/test-middle-banner" element={<TestMiddleBanner />} />
        <Route path="/search-vehicles" element={<SearchVehicle />} />
        <Route path="/search-result" element={<SearchResult />} />
        <Route path="/inventory" element={<Inventory />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;